import React from 'react'
import Highcharts from 'highcharts'

import './BarChart.css'

const COLORS = {
  RED: '#ef9a9a',
  LIME: '#E6EE9C',
  BLUE: '#80DEEA',
  TEAL: '#80CBC4',
  ORANGE: '#FFCC80',
  INDIGO: '#9FA8DA',
}

export default class BarChart extends React.Component {
  componentDidMount() {
    const { data, title } = this.props.widget
    const colors = this.getColors()
    const config = this.getConfig({data, colors, title})

    Highcharts.chart('pieChart', config)

    // window.addEventListener('resize', () => this.resizeChart({ data, colors, title }))
  }

  // resizeChart({ data, colors, title }) {
  //   const w = document.getElementById('pieChart').closest(".pie-chart").offsetWidth
  //   console.log(w)
  //   if (w > 500 && w < 900) {
  //     const chart = Highcharts.chart('pieChart', this.getConfig({ data, colors, title }))
  //     chart.setSize(w, w/2, false)
  //   }
  // }

  renderMoreDescription () {
    const { widget } = this.props
    const { more } = widget
    const { title, desc } = more

    return (
      <div className="more-desc">
        <h3>{ title }</h3>
        <p>{ desc }</p>
      </div>
    )
  }

  getWidgetAlignDirection() {
    const { widget } = this.props
    if (!widget.more) {
      return 'row'
    }

    const { more } = widget
    const { align } = more

    return align === 'right' ? 'row-reverse' : 'row'
  }

  getColors() {
    let colors = []
    for (let color in COLORS) {
      colors.push(COLORS[color])
    }

    return colors
  }

  // predefined config
  // TODO make configurable from JSON directly
  getConfig({data, colors, title}) {
    const config = {
      title: {
        text: title,
        style: {
          display: 'none'
        }
      },
      chart: {
        backgroundColor: 'white',
        width: 360,
      },
      credits: {
        enabled: false
      },
      tooltip: {
        enabled: false
      },
      series: [{
        type: 'pie',
        borderColor: '#f2f2f2',
        borderWidth: 1,
        colors,
        cursor: 'pointer',
        dataLabels: {
          style: {
            fontSize: '0.8em',
            textOutline: null,
            color: 'darkslategray',
            fontWeight: 100
          },
          // connectorWidth: 2,
          distance: -40,
          // softConnector: 20,
          useHTML: true,
        },
        padding: 50,
        allowPointSelect: false,
        keys: ['name', 'y', 'selected', 'sliced'],
        data
      }],
      responsive: {
        rules: [{
            condition: {
                width: 300
            },
            chartOptions: {
                chart: {
                    className: 'small-chart'
                }
            }
        }]
    }
    }

    return config
  }

  render () {
    const { widget } = this.props

    return (
      <div className="bar-chart" style={{ flexDirection: this.getWidgetAlignDirection() }}>
        <div id='barChart'></div>
        { widget.more ? this.renderMoreDescription() : null }
      </div>
    )
  }
}
